import { apiClient } from './client'
import type {
  FeatureDefinition,
  FeatureDefinitionListResponse,
  FeatureDefinitionResponse,
  CreateFeatureDefinitionInput,
  UpdateFeatureDefinitionInput,
  FeatureCategory,
  DeprecateFeatureInput,
} from '@/types/feature-definition'

export const featureDefinitionsApi = {
  /**
   * List all feature definitions
   */
  list: async (params?: {
    categoryId?: string
    storageLocation?: string
    deprecated?: boolean
    search?: string
    page?: number
    pageSize?: number
  }): Promise<FeatureDefinitionListResponse> => {
    const response = await apiClient.get<FeatureDefinitionListResponse>('/feature-definitions', {
      params,
    })
    return response.data
  },

  /**
   * Get feature definition by ID
   */
  getById: async (id: string): Promise<FeatureDefinitionResponse> => {
    const response = await apiClient.get<FeatureDefinitionResponse>(`/feature-definitions/${id}`)
    return response.data
  },

  /**
   * Create new feature definition
   */
  create: async (data: CreateFeatureDefinitionInput): Promise<FeatureDefinitionResponse> => {
    const response = await apiClient.post<FeatureDefinitionResponse>('/feature-definitions', data)
    return response.data
  },

  /**
   * Update feature definition
   */
  update: async (
    id: string,
    data: UpdateFeatureDefinitionInput
  ): Promise<FeatureDefinitionResponse> => {
    const response = await apiClient.patch<FeatureDefinitionResponse>(
      `/feature-definitions/${id}`,
      data
    )
    return response.data
  },

  /**
   * Delete feature definition
   */
  delete: async (id: string): Promise<{ success: boolean; message?: string }> => {
    const response = await apiClient.delete(`/feature-definitions/${id}`)
    return response.data
  },

  /**
   * Deprecate feature definition
   */
  deprecate: async (
    id: string,
    data: DeprecateFeatureInput
  ): Promise<FeatureDefinitionResponse> => {
    const response = await apiClient.post<FeatureDefinitionResponse>(
      `/feature-definitions/${id}/deprecate`,
      data
    )
    return response.data
  },

  /**
   * List all feature categories
   */
  listCategories: async (): Promise<{ data: FeatureCategory[] }> => {
    const response = await apiClient.get<{ data: FeatureCategory[] }>(
      '/feature-definitions/categories'
    )
    return response.data
  },

  /**
   * Get features by category
   */
  getByCategory: async (categoryId: string): Promise<{ data: FeatureDefinition[] }> => {
    const response = await apiClient.get<{ data: FeatureDefinition[] }>(
      `/feature-definitions/categories/${categoryId}/features`
    )
    return response.data
  },
}
